/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Src_2_NameInputs */

const en_wb_management_src_2_name = /** @type {(inputs: Wb_Management_Src_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations tracker`)
};

const lv_wb_management_src_2_name = /** @type {(inputs: Wb_Management_Src_2_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbu uzskaite`)
};

/**
* | output |
* | --- |
* | "Operations tracker" |
*
* @param {Wb_Management_Src_2_NameInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_src_2_name = /** @type {((inputs?: Wb_Management_Src_2_NameInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Src_2_NameInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_src_2_name(inputs)
	return en_wb_management_src_2_name(inputs)
});